export enum InformationGroupType {
	ACCOMMODATION = 'ACCOMMODATION',
	ACTIVITY = 'ACTIVITY',
	POINT_OF_INTEREST = 'POINT_OF_INTEREST',
	SERVICE = 'SERVICE',
	ROUTE = 'ROUTE',
}
